// src/components/MinutesField.jsx
// 分数を直接打てる欄【2026-09-18】
//
//   プルダウンだと用意した値しか選べない。「17分後」にしたいときに困る。
//   打てる欄を主役にして、よく使う値はボタンで1回で入るようにする。
//
//   value は文字列。'' は「なし・しない」を表す（noneLabel を渡したときだけ選べる）。
import React from 'react';

const chip = {
  padding: '0.25rem 0.6rem', fontSize: '0.82rem', minHeight: '32px', borderRadius: 6,
};

/**
 * @param {string}   value      いまの値（'' は なし）
 * @param {function} onChange   (次の値: string) => void
 * @param {number[]} presets    ボタンで入れる値
 * @param {string}   noneLabel  「なし」を選べるようにする場合のラベル
 * @param {string}   unit       欄の右に出す単位（既定: 分後）
 */
export default function MinutesField({
  value, onChange, presets = [], noneLabel, unit = '分後', max = 1440, ariaLabel,
}) {
  const clean = (v) => {
    const t = String(v).replace(/[^0-9]/g, '');
    if (t === '') return '';
    return String(Math.min(parseInt(t, 10), max));
  };
  const is = (v) => String(v) === String(value);

  return (
    <span style={{ display: 'inline-flex', flexWrap: 'wrap', gap: '0.35rem', alignItems: 'center' }}>
      <input
        type="text" inputMode="numeric" value={value} aria-label={ariaLabel}
        placeholder={noneLabel ? 'なし' : ''}
        onChange={e => onChange(clean(e.target.value))}
        style={{ width: '4.5em', padding: '0.35rem 0.45rem', textAlign: 'right' }}
      />
      <span style={{ fontSize: '0.88rem' }}>{unit}</span>
      {noneLabel && (
        <button type="button" style={chip}
                className={value === '' ? 'btn-primary' : 'btn-secondary'}
                onClick={() => onChange('')}>{noneLabel}</button>
      )}
      {presets.map(p => (
        <button key={p} type="button" style={chip}
                className={is(p) ? 'btn-primary' : 'btn-secondary'}
                onClick={() => onChange(String(p))}>{p}</button>
      ))}
    </span>
  );
}
